import {
  ChangeDetectionStrategy,
  Component,
  SecurityContext,
  ViewEncapsulation,
  computed,
  inject,
  input,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aura-html-shadow',
  template: `<div [innerHTML]="safeHtml()"></div>`,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class AuraHtmlShadowComponent {
  html = input.required<string>();
  bypassSecurity = input.required<boolean>();

  safeHtml = computed<SafeHtml>(() => {
    const raw = this.html() ?? '';

    if (this.bypassSecurity()) {
      // NOSONAR: typescript:S6268 - Opt-in bypass isolated in Shadow DOM for trusted email previews
      return this.sanitizer.bypassSecurityTrustHtml(raw); // NOSONAR
    } else {
      const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, raw) ?? '';
      return sanitized as unknown as SafeHtml;
    }
  });

  private sanitizer = inject(DomSanitizer);
}
